import { z } from "zod";

export const uploadDocumentSchema = z.object({
  category: z.enum(["newsletter", "schedule", "indemnity", "general"]),
  description: z.string().max(500).optional(),
});

export const documentListQuerySchema = z.object({
  category: z.enum(["newsletter", "schedule", "indemnity", "general"]).optional(),
  pinned: z.enum(["true", "false"]).optional(),
});
